import { jsxs, jsx } from "react/jsx-runtime";
import Socials from "../../../buttons/Socials/Socials.js";
import Group from "../../../layout/Group/Group.js";
import TextLink from "../../../navigation/TextLink/TextLink.js";
import Heading from "../../../typography/Heading/Heading.js";
import Html from "../../../typography/Html/Html.js";
import { rem } from "@mantine/core";
import { F as FooterStyles } from "../../../../Footer.module-DJ70l-Jq.js";
const Contact = (props) => {
  const { header, description, phone, mail, facebookUrl, twitterUrl, instagramUrl, linkedInUrl } = props;
  return /* @__PURE__ */ jsxs(Group, { className: FooterStyles.contact, children: [
    /* @__PURE__ */ jsxs(Group, { direction: "column", spacing: rem("25px"), children: [
      /* @__PURE__ */ jsxs(Group, { spacing: rem("8px"), direction: "column", children: [
        header && /* @__PURE__ */ jsx(Heading, { type: "h3", text: header, variant: "light", tt: "uppercase" }),
        description && /* @__PURE__ */ jsx(Html, { html: `<p>${description}</p>`, variant: "neutral", condensed: true })
      ] }),
      /* @__PURE__ */ jsxs(Group, { direction: "column", spacing: rem("4px"), children: [
        phone && /* @__PURE__ */ jsx(
          TextLink,
          {
            weight: 600,
            text: phone.text,
            href: phone.href,
            color: "light",
            scale: 1.125,
            variant: "component"
          }
        ),
        mail && /* @__PURE__ */ jsx(
          TextLink,
          {
            text: mail.text,
            href: mail.href,
            color: "light",
            variant: "cta",
            weight: 600,
            scale: 1.125,
            iconColor: "light"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ jsx(
      Socials,
      {
        twitterUrl,
        facebookUrl,
        instagramUrl,
        linkedInUrl,
        variant: "neutral",
        direction: "column",
        size: "lg",
        spacing: rem("12px"),
        hiddenFrom: "xs"
      }
    )
  ] });
};
export {
  Contact as default
};
